export enum NotificationSeverity {
  success  = 'success',
  info     = 'info',
  warn     = 'warn',
  error    = 'error',
  business = 'business',
  custom   = 'custom'
}

type NotificationSeverityType =
  'success' | 'info' | 'warn' | 'error' | 'business' | 'custom';

export const BUSINESS_VALIDATION_TOAST_STYLE_CLASS = 'toast-business-validation';

export const BUSINESS_VALIDATION_DEFAULTS = {
  summary: 'Restricción de negocio',
  icon: 'fa-solid fa-shield-halved',
  life: 6000,
} as const;

export const ERROR_TOAST_STYLE_CLASS = 'toast-system-error';

export const ERROR_TOAST_DEFAULTS = {
  icon: 'fa-solid fa-circle-exclamation',
} as const;

export interface NotificationParams {
  severity          : NotificationSeverityType,
  summary           : string,
  detail?           : string,
  life?             : number,
  sticky?           : boolean,
  closable?         : boolean,
  icon?             : string,
  styleClass?       : string,
  contentStyleClass?: string,
  data?             : unknown,
  key?              : string,
  id?               : string
}

export interface NotificationServiceInterface {
  /**
   * [create]
   * @description Fires a notification
   * @param { NotificationParams } val
   *
   *
   *    - severity: Use 'NotificationSeverity' enum
   *    - summary, detail: are required fields
   *    - life: Time the notification is displayed
   *    - sticky: if true the notification will be displayed until the user close it
   *    - closable: Defines if the notification could be closed by the user
   *    @reference https://primeng.org/toast
   * @returns { void }
   * @memberof NotificationServiceInterface
   */
  create(val: NotificationParams):void;
  /**
   * [createMultiple]
   * @description Fires multiple notifications
   * @param { NotificationParams[] } val
   * @returns { void }
   * @memberof NotificationServiceInterface
   */
  createMultiple(val: NotificationParams[]): void;
  /**
   * [removeAllNotifications]
   * @description Removes all the notifications that are displayed.
   * @returns {void}
   * @memberof NotificationServiceInterface
   */
  removeAllNotifications(): void;
  /**
   * [removeNotification]
   * @description Removes and specific notification
   * @param {string} key
   * @returns {void}
   * @memberof NotificationServiceInterface
   */
  removeNotification(key: string): void;
  /**
   * [createBusinessValidation]
   * @description Displays a business-rule restriction as an informational alert,
   * not as a system error.
   */
  createBusinessValidation(params: Partial<Pick<NotificationParams, 'detail' | 'summary' | 'life' | 'sticky'>>): void;
}
